export default {
  researchAdvisor: {},
  researchAdvisors: [],
  advisor: {},
  students: [],
  advisorStudent: {},
}
